// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p9WVJ","colMin":"styles_colMin__24ukf"};